import React  from 'react';
import LayoutBasicInfoComponent from './layout-basic-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import LayoutCardComponent from './layout-card-info.component';


export const LayoutComponent = ({handleDelete,setPageData,paginationData,id,additionButtons,onEdit,cardDetails,columnDefs, pages,handleInnerFormChange,websites,selectedRoute,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Layout Information',
        component:<LayoutBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedRoute={selectedRoute}
        websites={websites}
        pages={pages}/>,
        isVisible:true,
    },
    {
      id:2,
      title:'Layout Card Information',
      component:<LayoutCardComponent 
      rowData={cardDetails}
      columnDefs={columnDefs}
      onEdit={onEdit}
      additionButtons={additionButtons}
      paginationData={paginationData}
      setPageData={setPageData}
      handleDelete={handleDelete}
      />,
      isVisible: id > 0 ? true : false,
  },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
    
    <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          >
            Back
          </button><button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}

            type="submit"
          >
              Save
            </button>
    
        
        </div>
       </div>
  )
}
export default LayoutComponent;
